export default function Promotions() {
  function toggleMenu(table, renameBtn) {
    table.classList.toggle('active');
    if (table.classList.contains('active')) {
      renameBtn.innerHTML = 'Скрыть';
      const parent = renameBtn.closest('.promotion_item');
      if (parent) {
        window.location.hash = `${parent.id}`;
      }
    } else {
      if (renameBtn.classList.contains('price-btn')) {
        renameBtn.innerHTML = 'Прайс-лист';
      } else {
        renameBtn.innerHTML = 'Подробнее';
      }
      window.location.hash = '-';
    }
  }

  const blueButton = document.querySelectorAll('[data-id="btn_table"]');
  if (blueButton) {
    blueButton.forEach((el) => {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        const promotionTable = this.closest('.promotion_item').querySelector('.hidden_list');
        const renameBtn = this.closest('.promotion_item').querySelector('.blue-btn');
        toggleMenu(promotionTable, renameBtn);
      });
    });
  }
}
